import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, map, switchMap } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ImageService {

	private readonly MAX_SIZE_IN_MB = 20;

	constructor(private http: HttpClient) { }

	convertFileToBase64(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

	isValidFile(file: File): { isValid: boolean, messageKey: string} {
		const fileSizeInMB = file.size / (1024 * 1024);
		if (fileSizeInMB > this.MAX_SIZE_IN_MB) {
			return { isValid: false, messageKey: 'error.max_size_exceded' };
		}
		return { isValid: true, messageKey: '' };
	}

  uploadFile(file: File | null): Observable<string> {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'image/png');
		const fileExtension: string = this.getFileExtension(file as File);
    return this.http.get(environment.BACKEND_API_URL + '/v1/file/' + fileExtension).pipe(
			map((res: any) => res.body ? res.body.url : null),
			switchMap((url: string) => {
				if (!url) {
					throw new Error('error.image_upload_failed');
				}
				return this.http.put(url, file, { headers, params: { 'no-token': 'true'} }).pipe(map(() => url))
			})
		);
  }

	private getFileExtension(file: File): string {
    const fileType = file.type || 'unknown';
    return fileType.split('/').pop() || 'unknown';
  }

}